
export default function ItemsDocument({ item, name, descrip, quantity,  
                                      handleEnterItem, handleQuantity}) {

  

  return (
    <div>
      <div className="flex border-b-2 border-slate-500 text-[9pt]">
        {/* <div><p>{item}</p></div> */}
        <div className="w-1/3">
          {name}
        </div>
        <div className="w-2/5">
          {descrip}
        </div>
        <div className="w-20 text-center">
          {quantity}
        </div>
        <input 
          className="border rounded w-20 text-center bg-gray-700" 
          type="number" name="quantity" 
          onChange={handleQuantity} 
          onKeyUp={(x) => handleEnterItem(x, quantity, item)} />
      </div>
    </div>
  );
}
